export const API_URI = process.env.REACT_APP_API_URI
export const API_URI_V2 = process.env.REACT_APP_API_URI_V2
export const OBX_KEY = process.env.REACT_APP_OBX_KEY
export const COOKIE_AUTH_NAME = process.env.REACT_APP_COOKIE_AUTH_NAME
export const WEBSOCK = process.env.REACT_APP_WEBSOCK